module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-input', {
    attrs: {
      "type": "textarea",
      "disabled": true
    },
    model: {
      value: (_vm.lastApprovalMemo),
      callback: function($$v) {
        _vm.lastApprovalMemo = $$v
      },
      expression: "lastApprovalMemo"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a4e964b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flow/LastApprovalMemo.vue
// module id = 692
// module chunks = 220